class productVariant extends HTMLElement {
    constructor() {
        super();
        this.token = "af4952a255de0d80866a400df9c2401d";
        this.version = "2026-04";
    }

    connectedCallback() {

    }
    // 获取价格
    formatMoney(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let s = "";
        const i = /\{\{\s*(\w+)\s*\}\}/
            , o = e || "${{amount}}";
        function r(t, e = 2, s = ",", i = ".") {
            if (isNaN(t) || null == t)
                return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) + (o[1] ? i + o[1] : "")
        }
        switch (o.match(i)[1]) {
            case "amount":
                s = r(t, 2);
                break;
            case "amount_no_decimals":
                s = r(t, 0);
                break;
            case "amount_with_comma_separator":
                s = r(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                s = r(t, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                s = r(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                s = r(t, 0, " ", "");
                break;
            case "amount_with_space_separator":
                s = r(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                s = r(t, 2, " ", ".")
        }
        return o.replace(i, s)
    }

    // 设置请求query
    queryInfo(type = '') {
        switch (type) {
            // 获取产品变体信息
            case 'getProduct':
                return `query getProduct($handle: String!) {
                    productByHandle(handle: $handle) {
                        id
                        title
                        options {
                            name
                            values
                        }
                        variants(first: 2048) {
                        edges {
                            node {
                                id
                                title
                                sku
                                availableForSale
                                inventoryQuantity

                                selectedOptions {
                                    name
                                    value
                                }

                                image {
                                    url
                                }
                                metafields(identifiers: [
                                    {namespace: "custom", key: "variant_icon"},
                                    {namespace: "custom", key: "variant_text"},
                                    {namespace: "theme", key: "color_description"}
                                ]) {
                                    namespace
                                    key
                                    value
                                }
                                }
                            }
                        }
                    }
                    }`
            default:
                break
        }
    }

    // 请求
    async request(query, parameter) {
        const shopInfo = window.Shopify || {}
        const res = await fetch(
            `https://${shopInfo.shop}/api/${this.version}/graphql.json`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.token
                },
                body: JSON.stringify({ query, variables: parameter })
            }
        )
        const data = await res.json()
        return data
    }

}
if (!customElements.get('product-variant')) {
    customElements.define('product-variant', productVariant);
}